import React, { useContext, useState } from "react";
import { AuthFetch } from "../../services/api";
import { notify, urlApiTMAN } from "../../utils/utils";
import { UserContext } from "../../context/provider/UserProvider";

export const useSalidaTraslado = () => {
    const { stateUser , signOut } = useContext(UserContext);
    const COD_EMPRESA = stateUser.codEmpresa
    const COD_USUARIO = stateUser.codUsuario

    const productoDefault = {
        codProducto: 0,
        serieProducto: false,
        cantidadProducto: 0,
        listaSeries: []
        // [
        //     {
        //         codSerieProducto: ""
        //     }
        // ]
    }

    const salidaDefault = {
        codEmpresa: COD_EMPRESA,
        codAlmacenOrigen: 0,
        codAlmacenDestino: 0,
        codUsuarioOrigen: COD_USUARIO,
        comentarioOrigen: "",
        codDocumento: 0,
        serieDocumento: "",
        correlativoDocumento: "",
        transferenciaDetalle: [productoDefault]        
        // {
        //     codProducto: 0,
        //     serieProducto: true,
        //     cantidadProducto: 0,
        //     listaSeries: [
        //         {
        //             codSerieProducto: ""
        //         }
        //     ]
        // }
    }

    const [listadoSalidasPorTraslado,setListadoSalidasPorTraslado] = useState([])
    const [ultimoDocumentoSalida,setUltimoDocumentoSalida] = useState({})
    const [salidaTrasladoAlmacen,setSalidaTrasladoAlmacen] = useState(salidaDefault)


    const listarSalidasPorTraslado = async ({
        fechaInicio = '',
        fechaFin = ''
    }) => {
        const response = await AuthFetch({
            url: urlApiTMAN + '/Transfer/Exit/warehouseTransfer?' + new URLSearchParams({
                CodEmpresa: COD_EMPRESA,
                CodUsuarioAccion: COD_USUARIO,
                FechaInicio: fechaInicio,
                FechaFin: fechaFin
            })
        })
        if(response.isValid){
            setListadoSalidasPorTraslado(response.content)
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const obtenerUltimoDocumentoSalida = async () => {
        const response = await AuthFetch({
            url: urlApiTMAN + '/Transfer/Exit/guide?' + new URLSearchParams({
                CodEmpresa: COD_EMPRESA,
                CodUsuarioAccion: COD_USUARIO
            })
        })
        if(response.isValid){
            setUltimoDocumentoSalida(response.content[0])
        }else{
            notify(response.exceptions[0].description,'error')
        }
    }

    const anularTransferencia = async ({
        codTransferencia = '',
        comentarioEliminacion = ''
    }) => {
        const response = await AuthFetch({
            url: urlApiTMAN + '/Transfer',
            method: 'DELETE',
            body: JSON.stringify({
                codEmpresa: COD_EMPRESA,
                codTransferencia: codTransferencia,
                codUsuarioAccion: COD_USUARIO,
                comentarioEliminacion: comentarioEliminacion
            })
        })
        return{
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ? response.content : response.exceptions[0].description
        }
    }

    const registrarSalidaPorTraslado = async ({
        codAlmacenOrigen = 0,
        codAlmacenDestino = 0,
        comentarioOrigen = "",
        codDocumento = 0,
        serieDocumento = "",
        correlativoDocumento = "",
        transferenciaDetalle = [] 
    }) => {
        const response = await AuthFetch({
            url: urlApiTMAN + '/Transfer/Exit',
            method: 'POST',
            body: JSON.stringify({
                codEmpresa: COD_EMPRESA,
                codAlmacenOrigen: codAlmacenOrigen,
                codAlmacenDestino: codAlmacenDestino,
                codUsuarioOrigen: COD_USUARIO,
                comentarioOrigen: comentarioOrigen,
                codDocumento: codDocumento,
                serieDocumento: serieDocumento,
                correlativoDocumento: correlativoDocumento,
                transferenciaDetalle: transferenciaDetalle  
            })
        })
        return {
            CodResultado: response.isValid ? 1 : 0,
            DesResultado: response.isValid ? response.content : response.exceptions[0].description
        }
    }

    const editarValorSalidaTraslado = ([key,value]) => {
        setSalidaTrasladoAlmacen(valAnterior => {
            return {
                ...valAnterior,
                [key]: value
            }
        })
    }
    
    return {
        listarSalidasPorTraslado,
        listadoSalidasPorTraslado,

        obtenerUltimoDocumentoSalida,
        ultimoDocumentoSalida,

        anularTransferencia,

        registrarSalidaPorTraslado,
        // salidaTrasladoAlmacen,
        // setSalidaTrasladoAlmacen,
        // salidaDefault,
        // editarValorSalidaTraslado
    }
};
